export default "__VITE_PUBLIC_ASSET__caa36d4c__"